module.exports = __webpack_public_path__ + "static/media/11.d9dcb969.jpg";